import { axiosService } from './axiosService';

const auth = () => axiosService.setAuth(true);

const unwrap = async (req: Promise<any>) => {
  try {
    const { data } = await req;
    return { ok: true, data: data?.data ?? data, raw: data };
  } catch (error: any) {
    const message =
      (error?.response?.data?.message) || error?.message || 'Request failed';
    return { ok: false, error: message };
  }
};

// "Notify me when available" demand leads raised from the Super Coach booking
// flow. Backend: GET/PATCH /admin/tutor-leads (super_admin only).
export const tutorLeadService = {
  list: (status: string, search: string, page = 1, limit = 30) =>
    unwrap(
      auth().get(
        `user/admin/tutor-leads?status=${encodeURIComponent(status || '')}&search=${encodeURIComponent(
          search || '',
        )}&page=${page}&limit=${limit}`,
      ),
    ),
  setStatus: (id: string, status: 'open' | 'notified' | 'closed') =>
    unwrap(auth().patch(`user/admin/tutor-leads/${id}/status`, { status })),
};
